import * as React from "react"
import style from "./ErrorScreen.module.scss"
import PrimaryButton from "../PrimaryButton/PrimaryButton"
interface ErrorScreenProps {
  onOkClicked: () => void
}

const ErrorScreen = ({ onOkClicked }: ErrorScreenProps) => {
  return (
    <div className={style.root}>
      <h3 className={style.title}>Sorry Something Went Wrong 😔</h3>
      <div className={style.message}>
        {" "}
        Please try again later or contact us at <a href="mailto:help@tombo.ai">help@tombo.ai.</a>
      </div>
      <div>
        <PrimaryButton onClick={onOkClicked}>Ok</PrimaryButton>
      </div>
    </div>
  )
}

export default ErrorScreen
